module.exports = __webpack_public_path__ + "static/media/icon-pro-expert.15b8a51f.svg";